import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  doorsFilterState,
  hasSelectedDoorsFilterSelector,
  resetSelectedDoorsFilterSelector,
  selectDoors,
  selectedDoorsFilterSelector,
  toggleDoors,
  visibleDoorsTypesSelector,
} from '@/states/filters/doors.state';

export function useDoorsFilter() {
  const [doorsFilter, setDoorsFilter] = useRecoilState(doorsFilterState);
  const selectedDoorsFilter = useRecoilValue(selectedDoorsFilterSelector);
  const toggleDoorsFilter = useSetRecoilState(toggleDoors);
  const selectDoorsFilter = useSetRecoilState(selectDoors);
  const resetSelectedDoorsFilter = useSetRecoilState(
    resetSelectedDoorsFilterSelector
  );
  const hasSelectedDoorsFilter = useRecoilValue(hasSelectedDoorsFilterSelector);
  const visibleDoorsFilters = useRecoilValue(visibleDoorsTypesSelector);

  return {
    doorsFilter,
    setDoorsFilter,
    selectedDoorsFilter,
    toggleDoorsFilter,
    resetSelectedDoorsFilter,
    hasSelectedDoorsFilter,
    selectDoorsFilter,
    visibleDoorsFilters,
  };
}
